import { useState, useEffect } from 'react';
import throttle from 'lodash/throttle';

import { MOBILE_BREAK_POINT } from 'shared/constants';

export enum BREAKPOINT {
  SM,
  LG
}

const getDeviceConfig = (width: number) => {
  if (width < MOBILE_BREAK_POINT) {
    return BREAKPOINT.SM;
  } else {
    return BREAKPOINT.LG;
  }
};

export const useBreakpoint = () => {
  const [brkPnt, setBrkPnt] = useState(() => getDeviceConfig(window.innerWidth));

  useEffect(() => {
    const calcInnerWidth = throttle(() => {
      setBrkPnt(getDeviceConfig(window.innerWidth));
    }, 200);
    window.addEventListener('resize', calcInnerWidth);
    return () => window.removeEventListener('resize', calcInnerWidth);
  }, []);

  return brkPnt;
};
